// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Languages
export const LANGUAGES = ['EN', 'EL', 'TR'] as const;
export type Language = typeof LANGUAGES[number];

// Accessible names for the two-letter language buttons
export const LANGUAGE_NAMES: Record<Language, string> = {
  EN: 'English',
  EL: 'Ελληνικά',
  TR: 'Türkçe',
};

// BCP 47 tags for <html lang>, so screen readers pick the right voice
export const HTML_LANG: Record<Language, string> = {
  EN: 'en',
  EL: 'el',
  TR: 'tr',
};

// App metadata
export const APP_META = {
  title: 'AREXPG',
  subtitle: 'Notes from Famagusta Gate',
  version: '0.1',
  year: 2026,
  location: {
    city: 'Nicosia',
    country: 'Cyprus',
    countryCode: 'CY',
    coordinates: {
      lat: 35.1729,
      lng: 33.3733,
    },
  },
  hotspots: 12,
  duration: '~ 25 min',
} as const;

// Breakpoints
export const BREAKPOINTS = {
  mobile: 768,
} as const;

// Local storage keys
export const STORAGE_KEYS = {
  language: 'arexpg-language',
  // Also read by public/ar/viewer.html before it loads gtag.js
  analyticsConsent: 'analytics-consent',
} as const;
